// extracted by mini-css-extract-plugin
export var completionBody = "_e9-2";
export var completionCard = "_e9-0";
export var completionFooter = "_e9-3";
export var completionTitle = "_e9-1";